







import { Component, Vue } from 'vue-property-decorator';
import MyRequest from '@/components/MyRequest/index.vue';
import Route from 'vue-router';

Component.registerHooks(['beforeRouteEnter']);

// This page only used for directly open /myrequest router
@Component({
  components: {
    MyRequest,
  },
})
export default class App extends Vue {
  fromHome = false;

  beforeRouteEnter (to: Route, from: any, next: Function) {
    next((vm: this) => {
      if (from.name === 'home') {
        vm.fromHome = true;
      }
    });
  }
}
